// PRO video-player
function initProVideoPlayer() {
  class ProVideoPlayer {
    constructor() {
      this.videoPlayers = document.querySelectorAll('[data-pro-video-player]');
      if (!this.videoPlayers.length) return;

      this.players = [];
      this.videoPlayers.forEach((player) => {
        const videoElement = player.querySelector('video');
        if (videoElement) {
          this.initPlayer(player, videoElement);
        }
      });
    }

    initPlayer(playerElement, videoElement) {
      const controls = playerElement.querySelector('[data-video-controls]');
      const playPauseBtn = playerElement.querySelector('[data-play-pause-btn]');
      const pauseIcon = playerElement.querySelector('[data-pause-icon]');
      const playIcon = playerElement.querySelector('[data-play-icon]');
      const progressCircle = playerElement.querySelector('[data-progress-circle]');

      if (!controls || !playPauseBtn || !pauseIcon || !playIcon || !progressCircle) return;

      const player = {
        element: playerElement,
        video: videoElement,
        controls: controls,
        playPauseBtn: playPauseBtn,
        pauseIcon: pauseIcon,
        playIcon: playIcon,
        progressCircle: progressCircle,
        isPlaying: !videoElement.paused,
      };

      if (player.isPlaying) {
        player.pauseIcon.style.display = 'flex';
        player.playIcon.style.display = 'none';
      } else {
        player.pauseIcon.style.display = 'none';
        player.playIcon.style.display = 'flex';
      }

      this.players.push(player);
      this.setupEventListeners(player);
      this.setupProgressTracking(player);
      this.setupBackgroundDetection(player);
    }

    setupEventListeners(player) {
      player.playPauseBtn.addEventListener('click', () => {
        this.togglePlayPause(player);
      });

      player.video.addEventListener('play', () => {
        player.isPlaying = true;
        player.pauseIcon.style.display = 'flex';
        player.playIcon.style.display = 'none';
      });

      player.video.addEventListener('pause', () => {
        player.isPlaying = false;
        player.pauseIcon.style.display = 'none';
        player.playIcon.style.display = 'flex';
      });

      player.video.addEventListener('ended', () => {
        if (player.video.loop) {
          player.isPlaying = true;
          player.pauseIcon.style.display = 'flex';
          player.playIcon.style.display = 'none';
        } else {
          player.isPlaying = false;
          player.pauseIcon.style.display = 'none';
          player.playIcon.style.display = 'flex';
          player.video.currentTime = 0;
        }
      });
    }

    togglePlayPause(player) {
      if (player.isPlaying) {
        player.video.pause();
      } else {
        player.video.play().catch((error) => console.log('Video play failed:', error));
      }
    }

    setupProgressTracking(player) {
      const circumference = 2 * Math.PI * parseFloat(player.progressCircle.getAttribute('r'));
      player.progressCircle.style.strokeDasharray = `${circumference} ${circumference}`;

      const updateProgress = () => {
        if (!player.video) return;

        const currentTime = player.video.currentTime;
        const duration = player.video.duration;

        if (duration > 0) {
          const progressPercent = (currentTime / duration) * 100;
          const offset = circumference - (progressPercent / 100) * circumference;
          player.progressCircle.style.strokeDashoffset = offset;
        }

        if (player.isPlaying) {
          requestAnimationFrame(updateProgress);
        }
      };

      player.video.addEventListener('play', () => {
        requestAnimationFrame(updateProgress);
      });

      if (player.isPlaying) {
        requestAnimationFrame(updateProgress);
      }
    }

    setupBackgroundDetection(player) {
      const video = player.video;
      const controls = player.controls;
      const progressRingBg = player.element.querySelector('.pro-video-player__progress-ring-bg');
      const progressRingCircle = player.element.querySelector('.pro-video-player__progress-ring-circle');

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      function analyzeFrameAndAdjustControls() {
        if (!video.videoWidth || !video.videoHeight) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const videoRect = video.getBoundingClientRect();
        const controlsRect = controls.getBoundingClientRect();

        const relX = (controlsRect.left - videoRect.left + controlsRect.width / 2) / videoRect.width;
        const relY = (controlsRect.bottom - videoRect.top - controlsRect.height / 2) / videoRect.height;

        const sampleX = Math.floor(relX * canvas.width);
        const sampleY = Math.floor(relY * canvas.height);

        try {
          const radius = (Math.max(controlsRect.width, controlsRect.height) * (canvas.width / videoRect.width)) / 2;
          const imageData = ctx.getImageData(
            Math.max(0, sampleX - radius),
            Math.max(0, sampleY - radius),
            Math.min(radius * 2, canvas.width - sampleX + radius),
            Math.min(radius * 2, canvas.height - sampleY + radius)
          );

          let totalBrightness = 0;
          const data = imageData.data;
          for (let i = 0; i < data.length; i += 4) {
            const brightness = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
            totalBrightness += brightness;
          }

          const avgBrightness = totalBrightness / (data.length / 4);
          const isDark = avgBrightness < 128;

          if (isDark) {
            progressRingBg.setAttribute('stroke', '#888888');
            progressRingCircle.setAttribute('stroke', '#FFFFFF');

            player.element
              .querySelectorAll('.pro-video-player__pause-icon svg path, .pro-video-player__play-icon svg path')
              .forEach((path) => {
                path.setAttribute('fill', '#FFFFFF');
              });

            controls.classList.add('pro-video-player__controls--on-dark');
            controls.classList.remove('pro-video-player__controls--on-light');
          } else {
            progressRingBg.setAttribute('stroke', '#D9D9D9');
            progressRingCircle.setAttribute('stroke', '#000000');

            player.element
              .querySelectorAll('.pro-video-player__pause-icon svg path, .pro-video-player__play-icon svg path')
              .forEach((path) => {
                path.setAttribute('fill', '#000000');
              });

            controls.classList.add('pro-video-player__controls--on-light');
            controls.classList.remove('pro-video-player__controls--on-dark');
          }
        } catch (e) {
          console.error('Error analyzing video frame:', e);
        }
      }

      let frameAnalysisInterval;

      video.addEventListener('loadedmetadata', analyzeFrameAndAdjustControls);
      video.addEventListener('play', function () {
        clearInterval(frameAnalysisInterval);
        frameAnalysisInterval = setInterval(analyzeFrameAndAdjustControls, 1000);
        analyzeFrameAndAdjustControls();
      });

      video.addEventListener('pause', function () {
        clearInterval(frameAnalysisInterval);
      });

      video.addEventListener('ended', function () {
        clearInterval(frameAnalysisInterval);
      });
    }
  }
  return new ProVideoPlayer();
}

document.addEventListener('DOMContentLoaded', function () {
  const hasVideoPlayers = document.querySelector('[data-pro-video-player]');
  if (hasVideoPlayers) {
    initProVideoPlayer();
  }
});
